/**
 * @generated SignedSource<<0701b9fe0c90bea89d61a92c9c6ed0da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type liveArticleArticle$data = {
  readonly entityId: string;
  readonly entityUuid: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleBaseAdvertisingInfoArticle" | "articleImageGalleryContent" | "contentLiveArticleArticle" | "globalCheckerContent" | "helpersCheckHasLiveTagArticle" | "newsletterWidgetLiveArticleArticle" | "shareArticle20Content">;
  readonly " $fragmentType": "liveArticleArticle";
};
export type liveArticleArticle$key = {
  readonly " $data"?: liveArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"liveArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "liveArticleArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityUuid",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleImageGalleryContent"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckHasLiveTagArticle",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "flattenTypeIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LiveArticle",
          "kind": "LinkedField",
          "name": "liveArticle",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentLiveArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "globalCheckerContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "newsletterWidgetLiveArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "shareArticle20Content"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleBaseAdvertisingInfoArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "aefbdec5dc0da5b131d9b5c18160f3dd";

export default node;
